import React, {Component} from "react";
import Tools from "../../../Tools";

class FormControlBase extends Component {
    getSizeFromProps = () => {
        const {size, xl, lg, md, sm} = this.props;
        const def = "md";

        if (size) return size;
        else if (xl) return "xl";
        else if (lg) return "lg";
        else if (md) return "md";
        else if (sm) return "sm";
        else return def;
    };


    getColorFromProps = () => {
        const {color, primary, secondary, tertiary, toggleActive, toggleInActive, darkToggleActive, darkToggleInactive} = this.props;
        const defaultType = "primary";

        if (color) return Tools.convertToDashCase(color);
        else if (primary) return "primary";
        else if (secondary) return "secondary";
        else if (tertiary) return "tertiary";
        else if (toggleActive) return "toggle-active";
        else if (toggleInActive) return "toggle-inactive";
        else if (darkToggleActive) return "dark-toggle-inactive";
        else if (darkToggleInactive) return "dark-toggle-inactive";
        else return defaultType;
    };

    getNameFromProps = () => this.props.name;

    getComponentClassName = () => '';
}

export default FormControlBase;
